import { render, staticRenderFns } from "./SerpMetaDescs.vue?vue&type=template&id=1b4de94a&scoped=true&"
import script from "./SerpMetaDescs.vue?vue&type=script&lang=js&"
export * from "./SerpMetaDescs.vue?vue&type=script&lang=js&"
import style0 from "./SerpMetaDescs.vue?vue&type=style&index=0&id=1b4de94a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4de94a",
  null
  
)

/* custom blocks */
import block0 from "./SerpMetaDescs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports